"use client";

export default function SettingsHeader() {
  return (
    <div className="flex items-center w-full">
      <h1 className="text-lg font-medium text-white">Settings</h1>
    </div>
  );
}
